<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='金牌讲解员'">



    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import {} from "@/service/getData";
  import {wxGetPosition,wxShareme} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        loadEnd: false, //数据加载结束则赋值为true
        TimeStamp: new Date().getTime(),  //获取当前时间
        P400: 0, //系统维护中
      }
    },
    computed: {},

    created(){

    },


    methods: {

    },
    watch: {},
    components: {
        P400
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/home/pay.vue